module.exports = __webpack_public_path__ + "img/icon-setting.baeaa549.svg";